import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode:"history",
    routes: [
        {
            path: "/",
            name: "main",
            component: () => import("@/views/index.vue"),
            meta: { title: "trackful" },
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js